import { useCallback } from 'react'
import * as Form from '../form'
import * as Stores from '../stores'

export function useSubmitCardApplication() {
  const cardApplication = Stores.useCardApplicationFormStore((s) => s.cardApplication)
  const cardApplicationForm = Stores.useCardApplicationFormStore((s) => s.cardApplicationForm)
  const [submit] =
    Stores.CardApplicationApi.endpoints[
      'POST /card/onboarding/applications/:applicationId/submit'
    ].useMutation()

  const submitCardApplication = useCallback(async () => {
    if (!cardApplication) {
      console.error('No card application found')
      return false
    }

    const parsedCardApplicationForm = Form.CardApplicationFormSchema.safeParse({
      ...cardApplicationForm,
      // HACK: Workaround from this being called in the `handleSubmit` callback of the `AgreementScreen`
      // which updates the Zustand store, invalidating this callback's memoized value.
      acceptCardholderAgreement: true,
    })

    // DOB is `optional` in the schema because we don't have a clean way to represent "unset" dates that aren't `undefined`.
    if (!parsedCardApplicationForm.success || !parsedCardApplicationForm.data.dob) {
      return false
    }

    const result = await submit({
      params: {
        applicationId: cardApplication.id,
      },
      body: {
        ssn: parsedCardApplicationForm.data.ssn,
        dateOfBirth: parsedCardApplicationForm.data.dob,
        income: Number(parsedCardApplicationForm.data.totalAnnualIncome),
        consentTimestamp: new Date().toISOString(),
        monthlyHousingPayment: Number(parsedCardApplicationForm.data.monthlyHousingPayment),
        referralCode: parsedCardApplicationForm.data.offerCode,
      },
    })

    return Boolean(result.data?.success)
  }, [cardApplication, cardApplicationForm, submit])

  return {
    submitCardApplication,
  }
}
